export const ALL_LOCATIONS_ID = 'all_locations';
export const ALL_LOCATIONS_NAME = 'All Locations';

export const resolveReservationLocationId = (locations, locationName) => {
  if (!Array.isArray(locations)) return '';
  const selected = locations.find(
    (location) => location?.location_name === locationName
  );
  return String(selected?.location_id ?? '').trim();
};

export const getDefaultReservationLocationName = (locations) => {
  if (!Array.isArray(locations) || locations.length === 0) return '';

  const allLocations = locations.find(
    (location) => String(location?.location_id ?? '').trim() === ALL_LOCATIONS_ID
  );
  if (allLocations) return ALL_LOCATIONS_NAME;

  const realLocations = locations.filter(
    (location) => String(location?.location_id ?? '').trim()
      && String(location?.location_id ?? '').trim() !== ALL_LOCATIONS_ID
      && String(location?.location_name ?? '').trim()
  );

  return realLocations.length === 1
    ? String(realLocations[0].location_name).trim()
    : '';
};

export const buildReservationCarClassOptions = (records) => {
  const options = [{ value: 'All', label: 'All' }];
  const seen = new Set(['All']);

  (Array.isArray(records) ? records : []).forEach((record) => {
    const code = String(record?.SIPP_code ?? '').trim().toUpperCase();
    if (code && !seen.has(code)) {
      options.push({ value: code, label: code });
      seen.add(code);
    }
  });

  return options;
};
